import { ArrowRight, FolderClosed } from "lucide-react";
import React, { useEffect, useState } from "react";
// import useAuth from "../../../hooks/useAuth";
// import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";
import { Flip, ToastContainer, toast } from "react-toastify";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useAuth from "../../hooks/useAuth";
const WithdrawReqModal = ({ visible, onClose, data }) => {
  const { authenticated, setAuthenticated } = useAuth();
  console.log(data, "this is data");

  const axiosPrivate = useAxiosPrivate();
  // Local state for balance
  const navigate = useNavigate();

  const handleOnClose = (e) => {
    if (e.target.id === "WithdrawReqModalContainer") {
      onClose();
    }
  };
  if (!visible) {
    return null;
  }
  const handleSubmit = async () => {
    console.log("first this is submit from modal");
    await axiosPrivate
      .get(`/easypaisa/UpdateWithdrawRequest/${data?._id}`, {
        withCredentials: true,
        params: {
          status: "accepted", // Example: filtering by game
        },
      })
      .then((res) => {
        console.log(res?.data);
        toast.success("Your Request has been submitted successfully! 👌", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Flip,
        });
        onClose();
        //   setFiles([]);

        //   setDisabled(false);
        //   document.getElementById("depositForm").reset();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Flip,
        });
        //   setDisabled(false);
        //   document.getElementById("depositForm").reset();
      });
    // console.log(authenticated?.user);
  };

  const handleRejectSubmit = async () => {
    console.log("first this is submit from modal");
    await axiosPrivate
      .get(`/easypaisa/UpdateWithdrawRequest/${data?._id}`, {
        withCredentials: true,
        params: {
          status: "rejected", // Example: filtering by game
        },
      })
      .then((res) => {
        console.log(res?.data);
        toast.success("Your Request has been submitted successfully! 👌", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Flip,
        });
        onClose();
        //   setFiles([]);

        //   setDisabled(false);
        //   document.getElementById("depositForm").reset();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Flip,
        });
        //   setDisabled(false);
        //   document.getElementById("depositForm").reset();
      });
    // console.log(authenticated?.user);
  };
  return (
    <div>
      <div
        id="WithdrawReqModalContainer"
        onClick={handleOnClose}
        className="fixed inset-0 z-[1001] bg-black bg-opacity-30 backdrop-blur flex justify-center items-center"
      >
        <ToastContainer />
        <div className="bg-black shadow-lg rounded-xl">
          <div className="flex flex-end justify-end">
            <button onClick={onClose} className="mt-1 me-1 mb-1">
              {/* <CloseSVG /> */}
            </button>
          </div>
          {/* {modalData} */}
          <div className="container bg-black p-4 rounded-xl bg-opacity-50 mx-auto ">
            <ToastContainer />
            {authenticated?.user?.role == "admin" ? (
              <>
                <div className="flex m-2">
                  <div>
                    <img
                      src={data?.user?.profilePicture}
                      className="w-10 h-10 rounded-full"
                    />
                  </div>
                  <div className="ms-5">
                    <p>{data?.user?.name}</p>
                    <p>{data?.user?.pubgName} - pubg Name</p>
                    <p>{data?.user?.pubgId} - pubg Id</p>
                  </div>
                </div>
                <div>
                  <div className="text-sm uppercase font-bold">
                    current Balance : {data?.user?.balance} PKR
                  </div>
                </div>
              </>
            ) : (
              <>
                <p>Withdraw Request # {data?.withdrawId}</p>
              </>
            )}
            <div id="easypaisa" className="mt-2">
              <div className="">
                <div>
                  <div>
                    <label>To Name : </label>
                    <small>Name Should be exact on Easypaisa.</small>
                  </div>
                  <p className="text-sm text-blue-500 font-bold">
                    {data?.easypaisaName}
                  </p>
                </div>
                <div>
                  <div>
                    <label>To Number : </label>
                    <small>Number Should be exact on Easypaisa.</small>
                  </div>
                  <p className="text-sm text-blue-500 font-bold">
                    {data?.easypaisaNumber}
                  </p>
                </div>
                <div>
                  <div>
                    <label>Amount (PKR) : </label>
                  </div>
                  <p className="text-sm text-blue-500 font-bold">
                    {data?.easypaisaAmount} PKR
                  </p>
                </div>
              </div>
            </div>
          </div>
          {authenticated?.user?.role == "admin" ? (
            <>
              <div className="px-5 pb-5 ">
                <div className="flex justify-between items-center">
                  <button
                    onClick={handleSubmit}
                    className="mt-5 tracking-wide flex justify-between px-3 font-semibold bg-green-500 text-white-500 w-[200px] py-4 rounded-lg hover:bg-green-700 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
                  >
                    <p> Accept</p> <ArrowRight />
                  </button>
                  <button
                    onClick={handleRejectSubmit}
                    className="mt-5 tracking-wide flex justify-between px-3 font-semibold bg-red-500 text-white-500 w-[200px] py-4 rounded-lg hover:bg-red-700 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
                  >
                    <p> Decline</p>X
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div className="flex justify-center items-centers mb-3">
              <button
                className={`mt-5 tracking-wide  px-3 font-semibold ${
                  data?.status == "inProgress"
                    ? "bg-blue-500"
                    : data?.status == "accepted"
                    ? "bg-green-500"
                    : data?.status == "rejected"
                    ? "bg-red-500"
                    : ""
                } text-white-500 text-sm w-[200px] py-2 rounded-lg   transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none`}
              >
                {data?.status}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WithdrawReqModal;
